import { bookExtractHeaders } from "../BookTable/headers";
import { Book } from "../BookExtracts/types";

interface BookTableRowProps {
  book: Book;
  index: number;
}
function BookTableRow({ book, index }: BookTableRowProps) {
  return (
    <tr>
      {bookExtractHeaders.map((column) => (
        <td
          key={column.key}
          data-label={column.label}
          className={column.className}
        >
          {column.render(book, index)}
        </td>
      ))}
    </tr>
  );
}

export default BookTableRow;
